import { useFeatureFlagEnabled } from 'posthog-js/react';
import { useLocation } from 'react-router';

import { useFirebase } from '../application/context/firebase';
import { AssistantProvider } from '../application/Provider/Assistant';
import { YbugProvider } from '../application/Provider/Ybug';
import { FeatureFlag } from '../types';

export const AssistantWrapper = ({ children }: { children: React.ReactNode }) => {
  const { authenticated } = useFirebase();
  const location = useLocation();
  const isNewAssistantEnabled = useFeatureFlagEnabled(FeatureFlag.NEW_ASSISTANT);
  const newAppLocation =
    location.pathname === '/home' ||
    location.pathname === '/chat' ||
    location.pathname.match(/^\/chat\/[^/]+(?:\/[^/]+)?$/) ||
    location.pathname === '/tasks' ||
    location.pathname.startsWith('/reporting') ||
    location.pathname.startsWith('/custom-data') ||
    location.pathname.startsWith('/products') ||
    location.pathname.startsWith('/suppliers') ||
    location.pathname.startsWith('/supplier-connection-requests') ||
    location.pathname.startsWith('/emission-factors') ||
    location.pathname.startsWith('/project') ||
    location.pathname.startsWith('/documents') ||
    location.pathname.startsWith('/questionnaire') ||
    location.pathname.startsWith('/app/settings');

  return (
    <YbugProvider
      settings={{
        hide_launcher: !!(isNewAssistantEnabled && authenticated),
      }}
    >
      {isNewAssistantEnabled ? (
        <AssistantProvider isAuthorized={authenticated} showWidget={!newAppLocation}>
          {children}
        </AssistantProvider>
      ) : (
        <>{children}</>
      )}
    </YbugProvider>
  );
};
